import dateTimeService from "app/services/date-time/dateTimeService";
import type { RawDate } from "app/UtilitiesAndConstants/types/dates";

export const compareItemsByDateDesc = (rawDateA: RawDate, rawDateB: RawDate): number => {
    const dateA = dateTimeService.getMoment(rawDateA);
    const dateB = dateTimeService.getMoment(rawDateB);

    return dateA.isBefore(dateB) || dateA.isSame(dateB) ? 1 : -1;
};

export const compareItemsByDateAsc = (rawDateA: RawDate, rawDateB: RawDate): number => {
    const dateA = dateTimeService.getMoment(rawDateA);
    const dateB = dateTimeService.getMoment(rawDateB);

    return dateA.isAfter(dateB) || dateA.isSame(dateB) ? 1 : -1;
};

export const sortNumbersDesc = (a: number, b: number): number => {
    return b - a;
};

export type SortOrder = "ascend" | "descend" | null | undefined;

const SORT_AFTER = 1;

export const compareLocaleStrings = (aVal: string, bVal: string, sortOrder?: SortOrder): number => {
    const isDescending = sortOrder === "descend";

    if (!aVal && !bVal) {
        return 0;
    }
    if (!aVal) {
        return isDescending ? -SORT_AFTER : SORT_AFTER;
    }
    if (!bVal) {
        return isDescending ? SORT_AFTER : -SORT_AFTER;
    }

    return aVal.localeCompare(bVal);
};

export const stringSorter =
    <T, K extends keyof T>(key: K) =>
    (a: T, b: T, sortOrder?: SortOrder): number =>
        compareLocaleStrings(String(a[key] ?? ""), String(b[key] ?? ""), sortOrder);

export const numberSorter =
    <T, K extends keyof T>(key: K) =>
    (a: T, b: T): number =>
        Number(a[key]) - Number(b[key]);
